// extracted by mini-css-extract-plugin
export default {"root":"_Y56LlYgjcp0Wyd4n1Td","width-default":"WL5iBOytlJcIpuO_4DSQ","width-100%":"SKGZGh3PHi7rYGNyO8NB"};